<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <h2>Réinitialisation du mot de passe</h2>
      @if (errorMessage) {
        <div class="alert alert-danger" role="alert">{{ errorMessage }}</div>
      }
      <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
        <div class="form-group mb-3">
          <label for="password">Nouveau mot de passe</label>
          <input
            type="password"
            id="password"
            class="form-control"
            formControlName="password"
            placeholder="Entrez votre mot de passe"
            autocomplete="new-password"
            />
            @if (resetForm.get('password')?.invalid && resetForm.get('password')?.touched) {
              <div class="text-danger">
                Le mot de passe est requis (minimum 6 caractères).
              </div>
            }
          </div>

          <div class="form-group mb-3">
            <label for="confirmPassword">Confirmez le nouveau mot de passe</label>
            <input
              type="password"
              id="confirmPassword"
              class="form-control"
              formControlName="confirmPassword"
              placeholder="Confirmez votre mot de passe"
              autocomplete="new-password"
              />

              <!-- Affiche un message d'erreur si la confirmation du mot de passe est invalide et touchée -->
              @if (resetForm.get('confirmPassword')?.invalid && resetForm.get('confirmPassword')?.touched) {
                <div class="text-danger">
                  <!-- Si la confirmation est requise -->
                  @if (resetForm.get('confirmPassword')?.errors?.['required']) {
                    <div>La confirmation du mot de passe est requise.</div>
                  }
                </div>
              }

              <!-- Affiche un message si les mots de passe ne correspondent pas -->
              @if (resetForm.errors?.['passwordMismatch'] && resetForm.get('confirmPassword')?.touched) {
                <div class="text-danger">
                  Les mots de passe ne correspondent pas.
                </div>
              }
            </div>

            <button type="submit" class="btn btn-primary" [disabled]="resetForm.invalid || isSubmitting">{{ isSubmitting ? 'Modification en cours…' : 'Réinitialiser' }}</button>
          </form>
        </div>
      </div>
    </div>
